export function calculateSplits(splits, itemAmount, selectedCategory, categories) {
    if (!splits || splits.length === 0) {
        splits = [{ category: null, categoryId: null, amount: itemAmount, description: "" }];
    }

    var results = categories.filter(c => c.Description === selectedCategory);
    if (results.length !== 1) {
        return {
            success: false,
            error: "Category not found",
            splits: splits
        };
    }

    var currentSplit = splits[splits.length - 1];
    currentSplit.categoryId = results[0].Id;
    currentSplit.category = selectedCategory;

    var sum = splits.reduce((acc, s) => acc + parseFloat(s.amount || 0), 0);
    var diff = itemAmount - sum;

    if (Math.abs(diff) >= 0.003) {
        splits.push({
            category: null,
            categoryId: null,
            amount: diff.toFixed(2),
            description: ""
        });
        return {
            success: true,
            isComplete: false,
            splits: splits
        };
    } else {
        return {
            success: true,
            isComplete: true,
            splits: splits
        };
    }
}

export function formatSplitPayload(splits) {
    return splits.map(e => ({
        categoryId: e.categoryId,
        amount: parseFloat(e.amount),
        description: e.description || ""
    }));
}

export function validateSplitsTotal(splits, targetAmount) {
    var sum = splits.reduce((acc, s) => acc + parseFloat(s.amount || 0), 0);
    return Math.abs(sum - targetAmount) < 0.005;
}
